import palette from '../palette';

export default {
  underline: {
    backgroundColor: 'rgba(194, 207, 224, 0.2)',
    border: 'none'
  }
};
